import { useEffect, useState } from 'react';

import { useCrossFlow } from '@atlassiansox/cross-flow-support';
import { useFeatureFlag } from '@trello/feature-flag-client';

import type { TouchpointSourceType } from '../TouchpointSourceType';
import type { TrelloCrossFlow } from '../TrelloCrossFlow';
import { isSourceTargetedByFeatureFlag } from './isSourceTargetedByFeatureFlag';

const CROSS_FLOW_FOR_1P_ADS = 'xf.cffe-for-1p-ads';

export const useCrossFlowFor1PAds = ({
  source,
  workspaceId,
}: {
  source: TouchpointSourceType;
  workspaceId?: string;
}) => {
  const crossFlow = useCrossFlow();

  const [crossFlowFor1PAds, setCrossFlowFor1PAds] = useState<TrelloCrossFlow>({
    isEnabled: false,
    reason: 'No matching experiment found',
  });

  const crossFlowFor1PAdsFeatureFlag = useFeatureFlag(
    CROSS_FLOW_FOR_1P_ADS,
    false,
  );

  useEffect(() => {
    if (
      crossFlow.isEnabled &&
      crossFlowFor1PAdsFeatureFlag &&
      isSourceTargetedByFeatureFlag({
        flagName: CROSS_FLOW_FOR_1P_ADS,
        source,
      })
    ) {
      setCrossFlowFor1PAds({
        isEnabled: true,
        open: () =>
          crossFlow.api.open({
            targetProduct: 'jira-core.ondemand',
            journey: 'get-started',
            sourceComponent: source,
            sourceContext: 'get-started',
            experimentalOptions: {
              isTrello1PAd: true,
              trelloWorkspaceId: workspaceId || null,
            },
          }),
      });
    }
    // Intentionally ignoring the crossFlow dependency
    // eslint-disable-next-line @trello/exhaustive-deps
  }, [crossFlowFor1PAdsFeatureFlag, source, workspaceId]);

  return crossFlowFor1PAds;
};
